export default "__VITE_ASSET__Br7eK13i__"